import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../Base/interceptors/PublicInterceptor";
import { fetchImagenProducto } from "../../Base/interceptors/PrivateInterceptor"

// get productos activos
export const getProductosActivos = async () => {
    const response = await PrivateInterceptor('productos/ProductosActivos', 'GET');
    return response;
}

export const getInventarioProductosExistentes = async () => {
    const result = await PrivateInterceptor('productos/DetalleInventarioProductosExistentes', 'POST');
    return result;
 }

 export const getProductos = async () =>{
    const result = await PrivateInterceptor('productos', 'GET');
    return result;
 }

 export const getProductsNames = async () =>{
    const result = await PrivateInterceptor('productos/ProductsNames', 'GET');
    return result;
 }
 
export const getImagenProductoServer = async(CodigoProducto) =>{
 
    const result = await PrivateInterceptor(`Global/Imagenes/getFileBase64/${CodigoProducto}`, 'GET')
    return result;
}

// export const getImagenProductoServer = async(CodigoProducto) => {
//     try {
//         const result = await fetchImagenProducto(`Global/Imagenes/getFileBase64/${CodigoProducto}`, 'GET');
        
//         // Si el result ya trae el error del catch del interceptor
//         if (result?.error) {
//             console.error("El servidor devolvió un error o formato inválido:", result.error);
//         }
        
//         return result;
//     } catch (err) {
//         console.error("Error en getImagenProductoServer:", err);
//         return null;
//     }
// }

export const getProductosRequisa = async (Codigo) => {
    const result = await PrivateInterceptor(`productos/ProductosRequisa`, 'GET')
    return result;
}
 
//  export const detRequisaMateriales = async (IdRequisa) => {
//     const result = await PrivateInterceptor(`Mantenimiento/Requisas/detallesRequisa/${IdRequisa}`, 'GET')
//     return result;
// }